document.addEventListener("DOMContentLoaded", function () {
  const splideEl = document.querySelector(".clinic-our-approach__carousel");

  if (!splideEl) return;

  splideEl.addEventListener("mounted", initZoomEffect);
  splideEl.addEventListener("updated", initZoomEffect);
  
  function initZoomEffect() {
    const splide = splideEl.splide;
    let zoomInterval;

    function applyZoom() {
      // Remove zoom class from all slides
      splide.Components.Slides.get().forEach(slide => {
        slide.slide.classList.remove("is-zoomed");
      });

      // Add zoom to active
      const active = splide.Components.Slides.getAt(splide.index);
      if (active) active.slide.classList.add("is-zoomed");
    }

    // Clear old interval if any
    clearInterval(zoomInterval);

    // Initial zoom
    applyZoom();

    // Zoom every 5 seconds
    zoomInterval = setInterval(applyZoom, 5000);

    // Reset + reapply when slide changes
    splide.on("move", () => {
      applyZoom();
    });
  }
});




document.addEventListener("DOMContentLoaded", () => {

  // Run only on desktop (>= 750px)
  if (window.innerWidth < 750) return;

  const cards = Array.from(document.querySelectorAll(".clinic-our-approach__approach-card"));
  if (!cards.length) return;

  let index = 0;
  const INTERVAL = 2000; // Every 2 seconds

  function cycleZoom() {
    cards.forEach(c => c.classList.remove("approach-zoom-in", "approach-zoom-out"));

    const current = cards[index];
    const prev = cards[(index - 1 + cards.length) % cards.length];

    current.classList.add("approach-zoom-in");

    if (prev) prev.classList.add("approach-zoom-out");

    index = (index + 1) % cards.length;
  }

  cycleZoom();
  setInterval(cycleZoom, INTERVAL);
});

